function OAuthCheckInterceptor (authUri) {
  function foo (req, next) {
    if (req.url.match(authUri)) {
      req.headers.set('Content-type', 'application/x-www-form-urlencoded')
    }
    next()
  }
  return foo
}

export default OAuthCheckInterceptor



// WEBPACK FOOTER //
// ./src/modules/authorization/middleware/OAuthCheckInterceptor.js